// TODO: [PROF-5358] Bring back analytics page with tabs, routing etc.

import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureFeatureEnabled,
  EnsureLoggedInAndRegistered,
  EnsureProfilePermission,
  WithLayout
} from "PFApp/routes/route_helpers";
import { PermissionRule } from "PFTypes";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { AnalyticsController } from "../analytics/analytics_controller";
import { AnalyticsTab } from "../analytics/context/analytics_context";

export const AnalyticsRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedInAndRegistered>
      <EnsureFeatureEnabled feature="insights_page">
        <EnsureProfilePermission permittedTo={PermissionRule.Reporter}>
          <WithLayout>
            <Switch>
              <Route exact path={path}>
                <AnalyticsController tab={AnalyticsTab.Reports} />
              </Route>
              {/* <Route exact path={`${path}/insights`}>
                <AnalyticsController tab={AnalyticsTab.Insights} />
              </Route> */}
              <Route exact path={`${path}/reports`}>
                <AnalyticsController tab={AnalyticsTab.Reports} />
              </Route>
              <Route path="*">
                <NotFoundRoute />
              </Route>
            </Switch>
          </WithLayout>
        </EnsureProfilePermission>
      </EnsureFeatureEnabled>
    </EnsureLoggedInAndRegistered>
  );
};
